module.exports = __webpack_public_path__ + "fonts/effect-new-mutants-c3733b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-new-mutants.svg
// module id = 802
// module chunks = 0